import Vue from 'vue'
import filters from './methods.js'

/**
 * Installing filters
 */
for (var filter in filters) {
    Vue.filter(filter, filters[filter])
}


// WEBPACK FOOTER //
// ./resources/assets/js/filters/index.js